import { OverlayModule } from '@angular/cdk/overlay';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { MatAutocompleteOriginDirective } from './autocomplete-origin.directive';
import {
  MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER,
  MatAutocompleteTriggerDirective,
} from './autocomplete-trigger.directive';
import { MatAutocompleteComponent } from './autocomplete.component';
import { OptionModule } from '../option';

@NgModule({
  imports: [OverlayModule, OptionModule, MatCommonModule, CommonModule],
  exports: [
    MatAutocompleteComponent,
    MatAutocompleteTriggerDirective,
    MatAutocompleteOriginDirective,
    CdkScrollableModule,
    OptionModule,
    MatCommonModule,
  ],
  declarations: [MatAutocompleteComponent, MatAutocompleteTriggerDirective, MatAutocompleteOriginDirective],
  providers: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class AutocompleteModule {}
